import styled from 'styled-components'

export const RadioButtonsContainer = styled.div`
  margin-top: 16px;
`
